import { useEffect } from 'react';
import { createUseRangeFilter, type IUseRangeFilterProps } from '@/creditflowresearch/ui/common/hooks/sidebar/useRangeFilter';
import {
  useCorporateBondScreenerSidebarFilterContext,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';
import type { TFilterPayload } from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilter';

const baseUseRangeFilter = createUseRangeFilter<TFilterPayload>(useCorporateBondScreenerSidebarFilterContext);

const useRangeFilter = (props: IUseRangeFilterProps<TFilterPayload>) => {
  const { setHasValidationError } = useCorporateBondScreenerSidebarFilterContext();
  const result = baseUseRangeFilter(props);

  useEffect(() => {
    setHasValidationError(result.hasError);
  }, [result.hasError, setHasValidationError]);

  return result;
};

export default useRangeFilter;
